export const DEFAULT_ABORT_ERROR_MESSAGE = 'The operation was aborted.';

export class AbortError extends Error {
	statusCode: number;

	constructor(message: string, statusCode = 499) {
		super(message);
		this.name = 'AbortError';
		this.statusCode = statusCode;
	}
}

/**
 * Checks if the provided error is an AbortError.
 *
 * @param {unknown} error - The error to check.
 * @returns {boolean} - Returns true if the error is an AbortError, false otherwise.
 */
export const isAbortError = (error: unknown): error is AbortError => error instanceof AbortError;
